import { useMutation, useQueryClient } from "@tanstack/react-query";
import { apiClient } from "../../../zodios/client";
import { errorToast, successToast } from "../../../utils/toasts";
import type { DataViewWriteBody } from "../../../zodios/apiDefinitions/api/dataViews";

type Vars = { id: number; body: DataViewWriteBody };

export const useUpdateDataView = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ id, body }: Vars) => await apiClient.updateDataView(body, { params: { id } }),
    onSuccess: () => {
      successToast({ message: "Data view updated" });
      void queryClient.invalidateQueries({ queryKey: [{ entity: "DataViews" }] });
    },
    onError: (error) => {
      errorToast({ message: "Couldn't update data view", error });
    },
  });
};
